import React from 'react'
import { Image, ImageStyle, View } from 'react-native'
import { StyleService, useStyleSheet } from '@src/style/service'
import { IconSource, IconSources } from '@src/assets/icons'
import { TerraProviderKind } from '@src/types'
import { Button, Icon, IconName, Text } from '../base'

interface IntegrationPromotionNotificationBannerProps {
  content: string
  actionButtonLabel: string
  dismissButtonLabel: string
  dismiss: () => void
  action: (() => void) | undefined
  payload: any
  iconName: IconName
}

const providerImageMap: Partial<Record<TerraProviderKind, IconSource>> = {
  [TerraProviderKind.MyFitnessPal]: IconSources.myFitnessPal,
}

export const IntegrationPromotionNotificationBanner = (
  props: IntegrationPromotionNotificationBannerProps,
) => {
  const styles = useStyleSheet(themedStyles)

  const {
    content,
    actionButtonLabel,
    dismissButtonLabel,
    dismiss,
    action,
    payload,
    iconName,
  } = props

  const { title, provider } = payload

  const providerKind: TerraProviderKind = provider
  const iconSource = providerImageMap[providerKind]

  return (
    <View style={styles.banner}>
      <View style={styles.contentWrapper}>
        {iconSource ? (
          <Image source={iconSource} style={styles.providerIcon as ImageStyle} />
        ) : (
          <Icon name={iconName} style={styles.icon} />
        )}

        <View style={styles.textWrapper}>
          {title && (
            <Text type="regular" bold>
              {title}
            </Text>
          )}
          <Text type="regular">{content}</Text>
        </View>
      </View>
      <View style={styles.buttonWrapper}>
        <Button
          type="transparent"
          size="small"
          accessibilityLabel={dismissButtonLabel}
          style={styles.button}
          onPress={dismiss}
        >
          {dismissButtonLabel}
        </Button>
        <Button
          type="primary"
          size="small"
          accessibilityLabel={actionButtonLabel}
          style={styles.button}
          onPress={action}
        >
          {actionButtonLabel}
        </Button>
      </View>
    </View>
  )
}

const themedStyles = StyleService.create({
  banner: {
    margin: 16,
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderRadius: 8,
    borderWidth: 2,
    borderColor: 'theme.surface.base1',
  },
  contentWrapper: {
    flexDirection: 'row',
    marginBottom: 12,
  },
  textWrapper: {
    flexDirection: 'column',
    flex: 1,
  },
  icon: {
    color: 'theme.warning.darkest',
    marginRight: 16,
  },
  buttonWrapper: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  button: {
    marginLeft: 8,
  },
  providerIcon: {
    width: 48,
    height: 48,
    marginRight: 12,
  },
})
